import { popupSelectorTypes } from 'store';

export const getTitle = key => {
  switch (key) {
    case popupSelectorTypes.addProduct:
      return 'Manage Attached Products';

    case popupSelectorTypes.addPerson:
      return 'Manage persons of your project';
  }
};
